import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/toolbox_assignments',
    name: 'ToolboxAssignment',
    component: {
      name: 'AdminToolboxAssignment',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'toolbox_assignment',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminToolboxAssignmentIndex',
        component: () => import('../views/admin/ToolboxAssignmentAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminToolboxAssignmentNew',
        component: () => import('../views/admin/ToolboxAssignmentAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminToolboxAssignmentIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminToolboxAssignmentShow',
        component: () => import('../views/admin/ToolboxAssignmentAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminToolboxAssignmentIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminToolboxAssignmentDetails',
            component: () => import('../views/admin/ToolboxAssignmentAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminToolboxAssignmentIndex' },
            },
          },
        ],
      },
    ]
  },
  {
    path: 'user/toolbox_assignments',
    name: 'UserToolboxAssignment',
    component: {
      name: 'UserToolboxAssignment',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'toolbox_assignment',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserToolboxAssignmentIndex',
        component: () => import('../views/user/ToolboxAssignmentUserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserToolboxAssignmentShow',
        component: () => import('../views/user/ToolboxAssignmentUserShow.vue'),
        meta: {
          backRoute: {
            name: 'UserToolboxAssignmentIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'UserToolboxAssignmentDetails',
            component: () => import('../views/user/ToolboxAssignmentUserDetails.vue'),
            meta: {
              backRoute: { name: 'UserToolboxAssignmentIndex' },
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));